import { render, staticRenderFns } from "./LessonMsgEditLayer.vue?vue&type=template&id=aae2e81a&scoped=true&"
import script from "./LessonMsgEditLayer.vue?vue&type=script&lang=js&"
export * from "./LessonMsgEditLayer.vue?vue&type=script&lang=js&"
import style0 from "./LessonMsgEditLayer.vue?vue&type=style&index=0&id=aae2e81a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae2e81a",
  null
  
)

export default component.exports